import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

/**
 * Retorna true se a tela for considerada mobile (breakpoint down('md') = < 960px).
 * Use para adaptar imagens e layout ao dispositivo.
 */
export default function useIsMobile() {
    const theme = useTheme();
    return useMediaQuery(theme.breakpoints.down("md"));
}
